export function isAnySendingMethodSelected(sendingMethods: {
  sendEmail: boolean;
  sendFloorApp: boolean;
  sendPortalMessage: boolean;
  sendSms: boolean;
}) {
  return Object.values(sendingMethods).some(Boolean);
}
